import { createSlice } from "@reduxjs/toolkit";

export const depositSlice = createSlice({
    name: 'deposit',
    initialState: {
        depositAccount: "blank",
        depositAmount: 0.00,
        validAmountCheck: true,
        confirming: false,
        status: ''
    },
    reducers: {
        setDepositAccount: (state, action) => {
            return {
                ...state,
                depositAccount: action.payload,
                status: ''
            }
        },
        changeDepositAmount: (state, action) => {
            return {
                ...state,
                depositAmount: action.payload.depositAmount,
                validAmountCheck: action.payload.validAmountCheck ? true : false
            }
        },
        clearDepositForm: (state) => {
            return {
                ...state,
                depositAccount: 'blank',
                depositAmount: 0.00,
                validAmountCheck: true,
            }
        },
        setConfirmingDeposit: (state, action) => {
            return {
                ...state,
                confirming: action.payload,
                status: ''
            }
        },
        changeDepositFormStatus: (state, action) => {
            return {
                ...state,
                status: action.payload
            }
        }
    }
})

export const selectDepositAccount = (state) => state.deposit.depositAccount;
export const selectDepositAmount = (state) => state.deposit.depositAmount;
export const selectDepositValidAmountCheck = (state) => state.deposit.validAmountCheck;
export const depositIsConfirming = (state) => state.deposit.confirming;
export const selectDepositFormStatus = (state) => state.deposit.status;

export const { setDepositAccount, changeDepositAmount, clearDepositForm, setConfirmingDeposit, changeDepositFormStatus } = depositSlice.actions;

export default depositSlice.reducer;
